import React from "react";
import { Card, Button, Typography, Result } from "antd";
import {
  CheckCircleOutlined,
  HomeOutlined,
  MailOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { primaryColor } from "../../utils/constants";

const { Title, Text, Paragraph } = Typography;

export const ApplicationSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const applicationId = location.state?.applicationId;
  const email = location.state?.email;

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-lg"
      >
        <Card
          className="rounded-3xl shadow-xl border-0 overflow-hidden text-center"
          style={{ boxShadow: "0 20px 60px rgba(164, 1, 101, 0.15)" }}
        >
          <Result
            icon={
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <CheckCircleOutlined
                  style={{
                    fontSize: "80px",
                    color: primaryColor,
                  }}
                />
              </motion.div>
            }
            title={
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.3 }}
              >
                <Title
                  level={2}
                  style={{ color: "#1a1a1a", marginBottom: "8px" }}
                >
                  Application Submitted Successfully!
                </Title>
              </motion.div>
            }
            subTitle={
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.4 }}
                className="space-y-4"
              >
                <Paragraph className="text-lg text-gray-600 mb-6">
                  Thank you for your interest in becoming a consultant with us.
                  Your application has been received and is under review.
                </Paragraph>

                {applicationId && (
                  <div className="bg-gray-50 p-4 rounded-xl mb-6">
                    <Text strong className="text-gray-700">
                      Application ID:
                    </Text>
                    <Text
                      className="ml-2 font-mono text-lg"
                      style={{ color: primaryColor }}
                    >
                      {applicationId}
                    </Text>
                  </div>
                )}

                {email && (
                  <div className="flex items-center justify-center mb-6">
                    <MailOutlined className="mr-2 text-gray-500" />
                    <Text className="text-gray-600">
                      We'll contact you at {email}
                    </Text>
                  </div>
                )}

                <div className="bg-blue-50 p-4 rounded-xl mb-6">
                  <Title level={5} className="text-blue-800 mb-2">
                    What happens next?
                  </Title>
                  <div className="text-left space-y-2">
                    <div className="flex items-start">
                      <div className="w-2 h-2 rounded-full bg-blue-500 mt-2 mr-3 flex-shrink-0"></div>
                      <Text className="text-blue-700">
                        Our team will review your application within 2-3
                        business days
                      </Text>
                    </div>
                    <div className="flex items-start">
                      <div className="w-2 h-2 rounded-full bg-blue-500 mt-2 mr-3 flex-shrink-0"></div>
                      <Text className="text-blue-700">
                        You'll receive an email with the application status
                      </Text>
                    </div>
                    <div className="flex items-start">
                      <div className="w-2 h-2 rounded-full bg-blue-500 mt-2 mr-3 flex-shrink-0"></div>
                      <Text className="text-blue-700">
                        If approved, we'll guide you through the onboarding
                        process
                      </Text>
                    </div>
                  </div>
                </div>
              </motion.div>
            }
            extra={
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className="space-y-4"
              >
                <Button
                  type="primary"
                  size="large"
                  icon={<HomeOutlined />}
                  onClick={async () => {
                    localStorage.clear();
                    setTimeout(() => {
                      navigate("/");
                    }, 500);
                  }}
                  className="rounded-xl h-12 px-8 font-semibold"
                  style={{
                    backgroundColor: primaryColor,
                    borderColor: primaryColor,
                    background: `linear-gradient(135deg, ${primaryColor} 0%, ${primaryColor}DD 100%)`,
                  }}
                >
                  Go to Homepage
                </Button>
              </motion.div>
            }
          />
        </Card>
      </motion.div>
    </div>
  );
};
